(function () {
    const popUps = document.querySelectorAll('.pop-up');

    function closePopUp() {
        popUps.forEach(p => p.style.display = 'none');
        
        document.querySelectorAll('.advent-form').forEach(form => {
            form.style.display = 'none';
        });
        
        document.querySelectorAll('[id^="advent-success-"]').forEach(el => {
            el.classList.add('hidden');
        });
        
        document.querySelectorAll('[id^="advent-error-"]').forEach(el => {
            el.classList.add('hidden');
        });
        
        document.querySelectorAll('[id^="hint-text-"]').forEach(hint => {
            hint.classList.add('hidden');
        });
        
        document.querySelectorAll('[id^="tip-"]').forEach(tip => {
            tip.classList.remove('hidden');
        });
    }

    function openPopUp(id, state) {
        const getId = id.split('-')[2];
        const formId = document.querySelector('#advent-form-' + getId);
        const notActive = document.querySelector('#advent-form-notactive');
        const questionsPopUp = document.querySelector('.pop-up');

        if (!questionsPopUp) return;

        document.querySelectorAll('.advent-form').forEach(form => {
            form.style.display = 'none';
        });

        questionsPopUp.style.display = 'block';
        
        if (state && formId) {
            formId.style.display = 'block';
        } else if (notActive) {
            notActive.style.display = 'block';
        }
    }

    popUps.forEach(p => {
        p.querySelectorAll('.pop-up-overlay').forEach(overlay => {
            overlay.addEventListener('click', closePopUp);
        });

        p.addEventListener('click', function(e) {
            const closeButton = e.target.closest('.close');
            if (closeButton) {
                e.preventDefault();
                e.stopPropagation();
                closePopUp();
            }
        });
    });

    document.querySelectorAll('.advent-box').forEach((item) => {
        item.addEventListener('click', function () {
            openPopUp(this.id, this.classList.contains('active'));
        });
    });

    document.querySelectorAll('.tip').forEach((item) => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const id = item.id.split('-')[1];
            const tip = document.getElementById('tip-' + id);
            const hintText = document.getElementById('hint-text-' + id);
            
            if (tip) tip.classList.add('hidden');
            if (hintText) hintText.classList.remove('hidden');
        });
    });

    async function postData(url, data) {
        const response = await fetch(url, {
            method: 'POST',
            body: data
        });
        return response.ok;
    }

    const forms = document.getElementsByClassName("advent-form");
    for (let i = 0; i < forms.length; i++) {
        const id = forms[i].id.split("-")[2];
        
        if (id === "notactive") {
            continue;
        }

        forms[i].addEventListener('submit', async (e) => {
            e.preventDefault();
            
            const result = await postData(forms[i].getAttribute("action"), new FormData(forms[i]));
            
            forms[i].style.display = "none";
            
            if (result) {
                const successEl = document.getElementById("advent-success-" + id);
                if (successEl) successEl.classList.remove("hidden");
            } else {
                const errorEl = document.getElementById("advent-error-" + id);
                if (errorEl) errorEl.classList.remove("hidden");
            }
        });
    }

})();
